import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { Button, Row, Col } from "react-bootstrap";

const Timeline = ({ addFunction, children, style, showAddButton = true }) => {
  const AddEduButton = () => {
    return (
      <Button className="success" onClick={addFunction}>
        Add &nbsp;
        <FontAwesomeIcon icon={faAdd} />
      </Button>
    );
  };

  const dummyfunction = () => {};

  return (
    <>
      {showAddButton ? (
        <>
          <Row>
            <Col className="text-end">
              <AddEduButton />
            </Col>
          </Row>
          <br />
        </>
      ) : null}
      <Row>
        <Col>
          <div style={{
            position: "relative",
            paddingLeft: "28px",
            borderLeft: "2px solid #e0e0e0",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            ...style
          }}>
            {children}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Timeline;
